import { OrderBody } from '../types/types'
import { OrderConcept } from '../types/OrderConcept'

export const mapOrderBody = ({
  id,
  clientId,
  clientUuid,
  relation,
  tessaExpertNeeded,
  deliveryAddress,
  teamId,
  discipline,
  healthCareDemand,
  notes,
  internalNotes,
  requester,
  receiver,
  healthcareProfessional,
  integration,
  hardwareType
}: OrderConcept): OrderBody => {
  return {
    conceptOrderId: id,
    clientId,
    clientUuid,
    relationId: relation?.id,
    integrationId: integration?.id,
    tessaExpertNeeded: tessaExpertNeeded,
    deliveryAddress,
    teamId,
    discipline,
    healthCareDemand,
    notes,
    internalNotes,
    requester: {
      firstname: requester?.firstname,
      lastname: requester?.lastname,
      email: requester?.email,
      phoneNumber: requester?.phoneNumber
    },
    receiver,
    healthcareProfessional,
    hardwareType
  }
}
